import { render, staticRenderFns } from "./ComisionesIncentivos.vue?vue&type=template&id=46d12866&scoped=true"
import script from "./ComisionesIncentivos.vue?vue&type=script&lang=js"
export * from "./ComisionesIncentivos.vue?vue&type=script&lang=js"
import style0 from "./ComisionesIncentivos.vue?vue&type=style&index=0&id=46d12866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d12866",
  null
  
)

export default component.exports